import { render, staticRenderFns } from "./CancelWizardDialog.vue?vue&type=template&id=23c597d0&scoped=true&"
import script from "./CancelWizardDialog.vue?vue&type=script&lang=js&"
export * from "./CancelWizardDialog.vue?vue&type=script&lang=js&"
import style0 from "./CancelWizardDialog.vue?vue&type=style&index=0&id=23c597d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c597d0",
  null
  
)

export default component.exports